try {
    $(document).ready(function () {
        var a = $('.product-dsp__inner--dsktp');
        var b = 'product-dsp__inner--dsktp--show';
        var c = $('.hide-product-dsp-ico');
        var d = 'hide-product-dsp-ico--rotate';
        var e = $('.product-dsp__inner--dsktp__bg');
        var f = 'product-dsp__inner--dsktp__bg--hide';

        $('#hide-product-dsp').click(function () {
            a.toggleClass(b);
            c.toggleClass(d);
            e.toggleClass(f);

            if (a.hasClass(b)) {
                $("#hide-product-dsp-change-word").text(" mniej");
            } else {
                setTimeout(function () {
                    $("#hide-product-dsp-change-word").text(" więcej");
                }, 300);
            }
        });

        $('.product-dsp__inner--dsktp__bg').click(function () {
            a.toggleClass(b);
            c.toggleClass(d);
            e.toggleClass(f);

            if (a.hasClass(b)) {
                setTimeout(function () {
                    $("#hide-product-dsp-change-word").text(" więcej");
                }, 400);
            } else {
                $("#hide-product-dsp-change-word").text(" mniej");
            }
        });
    });
} catch (error) {
    console.error(error)
}